import Code from "./components/code";
import Home from "./pages/Home";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/code" element={<Code />} />
      </Routes>
    </div>
  );
}

export default App;
